import RestBuilder from './RestBuilder';

const getDefaultRest = () => new RestBuilder()
  .mimeJson()
  .successCodes([200])
  .failureCodes([400, 401, 404, 500])
  .build();

const RestFactory = {
  getDefaultRest
};

export default RestFactory;



/** WEBPACK FOOTER **
 ** ./src/rest/RestFactory.js
 **/